<air-title [title]="content.title" [region]="region" [isFirst]="isFirst"></air-title>
<div *ngIf="canTransferPoints" [internalInnerHtml]="content.description" [userEventSource]="userEventSource"></div>
<div
  *ngIf="content.alternateDescription && !canTransferPoints"
  [internalInnerHtml]="content.alternateDescription"
  [userEventSource]="userEventSource"
></div>
<!-- transfer methods section -->
<div *ngIf="canTransferPoints" class="interactive-block form">
  <h3>{{ "transfer_points.transfer_method.title" | translate }}</h3>
  <div class="button__group">
    <!-- email address button -->
    <ng-container
      [ngTemplateOutlet]="transferMethodButton"
      [ngTemplateOutletContext]="{
        type: 'emailAddress',
        label: 'account.label.email' | translate
      }"
    ></ng-container>
    <!-- card number button -->
    <ng-container
      [ngTemplateOutlet]="transferMethodButton"
      [ngTemplateOutletContext]="{
        type: 'cardNumber',
        label: 'account.label.card_number' | translate
      }"
    ></ng-container>
  </div>
  <!-- email address input field -->
  <div class="form-group" [hidden]="transferMethodType !== transferMethod.emailAddress">
    <label
      for="transfer-method--email-address"
      [ngClass]="{
        'form-label--error': emailAddress.dirty && emailAddress.invalid
      }"
    >
      {{ "transfer_points.transfer_method.label.email" | translate }}
    </label>
    <input [formControl]="emailAddress" type="email" id="transfer-method--email-address" />
    <div class="form-error" *ngIf="emailAddress.dirty && emailAddress.invalid">
      <div *ngIf="emailAddress.hasError('email')" class="form-error__message">{{ "account.error.email.invalid" | translate }}</div>
      <div *ngIf="emailAddress.hasError('required')" class="form-error__message">{{ "account.error.email.required" | translate }}</div>
    </div>
  </div>
  <!-- card number input field -->
  <div class="form-group" [hidden]="transferMethodType !== transferMethod.cardNumber">
    <label
      for="transfer-method--card-number"
      [ngClass]="{
        'form-label--error': cardNumber.dirty && cardNumber.invalid
      }"
    >
      {{ "transfer_points.transfer_method.label.card" | translate }}
    </label>
    <input [formControl]="cardNumber" type="text" id="transfer-method--card-number" />
    <div class="form-error" *ngIf="cardNumber.dirty && cardNumber.invalid">
      <div *ngIf="cardNumber.hasError('pattern')" class="form-error__message">{{ "account.error.card_number.invalid" | translate }}</div>
      <div *ngIf="cardNumber.hasError('required')" class="form-error__message">{{ "account.error.card_number.required" | translate }}</div>
    </div>
    <small class="form__description">{{ "account.description.card_number" | translate }}</small>
  </div>
</div>

<!-- transfer points section -->
<div *ngIf="canTransferPoints" class="form">
  <h3>{{ "transfer_points.donation_suggestions.title" | translate }}</h3>
  <div class="button__group">
    <!-- donation suggestions points options -->
    <ng-container *ngIf="content.donationSuggestions">
      <ng-container *ngFor="let donationSuggestion of content.donationSuggestions">
        <ng-container
          [ngTemplateOutlet]="donationSuggestionSticker"
          [ngTemplateOutletContext]="{
            points: donationSuggestion.points,
            isValueVisible: true
          }"
        ></ng-container>
      </ng-container>
    </ng-container>
    <!-- all user's points option -->
    <ng-container
      *ngIf="currentUser?.balance"
      [ngTemplateOutlet]="donationSuggestionSticker"
      [ngTemplateOutletContext]="{
        points: currentUser?.balance,
        isFullAmount: true,
        label: 'transfer_points.donation_suggestions.label.all_points' | translate
      }"
    ></ng-container>
    <!-- custom value option -->
    <ng-container
      [ngTemplateOutlet]="donationSuggestionSticker"
      [ngTemplateOutletContext]="{
        points: null,
        isCustomValueOption: true,
        label: 'transfer_points.donation_suggestions.label.specified_points' | translate
      }"
    ></ng-container>
  </div>
  <!-- input field for custom value option -->
  <div class="form-group" [hidden]="!isCustomValueVisible">
    <label
      for="transfer-points--custom-value"
      [ngClass]="{
        'form-label--error': points.dirty && points.invalid
      }"
    >
      {{ "transfer_points.donation_suggestions.field.label" | translate }}
    </label>
    <input
      type="number"
      [formControl]="points"
      (change)="onCustomValueChange($event)"
      inputmode="decimal"
      id="transfer-points--custom-value"
    />
  </div>
  <div class="form-error" *ngIf="points.dirty && points.invalid">
    <div
      *ngIf="
        points.hasError('min') ||
        (points.hasError('max') && points.value && currentUser && currentUser.balance && points.value <= currentUser.balance)
      "
      class="form-error__message"
    >
      {{ "transfer_points.donation_suggestions.field.error.range" | translate }}
    </div>
    <div *ngIf="points.value && currentUser && currentUser.balance && points.value > currentUser.balance" class="form-error__message">
      {{ "transfer_points.donation_suggestions.field.error.balance" | translate }}
    </div>
  </div>
</div>
<!-- submit button -->
<button
  *ngIf="canTransferPoints"
  type="button"
  class="button form__button button--full-width button--cta"
  [disabled]="formDisabled"
  [airButtonLoading]="isSubmitting"
  (click)="submit($event)"
>
  <span>{{ "transfer_points.submit.btn_label" | translate }}</span>
</button>

<ng-template #transferMethodButton let-type="type" let-label="label">
  <div
    role="button"
    class="button"
    [ngClass]="{
      'button--primary': transferMethodType === type,
      'button--border': transferMethodType !== type
    }"
    (click)="setTransferMethodType(type, $event)"
  >
    <span>{{ label }}</span>
  </div>
</ng-template>

<ng-template
  #donationSuggestionSticker
  let-points="points"
  let-label="label"
  let-isValueVisible="isValueVisible"
  let-isCustomValueOption="isCustomValueOption"
  let-isFullAmount="isFullAmount"
>
  <div>
    <div
      #sticker
      class="sticker sticker--miles sticker--sm"
      [ngClass]="{ 'sticker--disabled': currentUser && currentUser.balance && points > currentUser.balance }"
      (click)="
        currentUser && currentUser.balance && points <= currentUser.balance
          ? onStickerClick(sticker, points, isCustomValueOption, isFullAmount)
          : null
      "
    >
      <ng-container *ngIf="isValueVisible; else showLabelTextOnly">
        <span class="sticker__counter">{{ points | formatNumber }}</span>
        <span class="sticker__label">{{ "general.label.air_miles" | translate }}</span>
      </ng-container>
      <ng-template #showLabelTextOnly>
        <span class="sticker__counter">{{ label }}</span>
      </ng-template>
    </div>
  </div>
</ng-template>
